module.exports = __webpack_public_path__ + "static/media/7-13.76c722ce.mp3";